import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KEY_VERSION } from '@app/app-components';
import { ValidadorSettingsUser } from '@app/shared/utils/validar_settings_user';
import { Observable, Subject, timer } from 'rxjs';
import { TokenService } from 'viggo-sistemas-core-web';
import { BuildDetails } from './build-details';
import { BuildDetailsService } from './build-details.service';

@Injectable({ providedIn: 'root' })
export class UpToDateBuildService {
  private buildIsUpToDateSubject = new Subject<boolean>();

  constructor(
    protected buildDetailsService: BuildDetailsService,
    protected tokenService: TokenService,
    private httpClient: HttpClient
  ) {
    this.pollForBuildNumber();
  }

  public get buildIsUpToDate(): Observable<boolean> {
    return this.buildIsUpToDateSubject;
  }

  private pollForBuildNumber() {
    const pollInterval = 3000;

    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache'
      })
    };

    timer(pollInterval, pollInterval).subscribe(() => {
      const domain = this.tokenService.getDomain();
      if (domain && domain.name.toUpperCase() !== 'DEFAULT') {
        this.httpClient
          .get<BuildDetails>('assets/build-details.json', httpOptions)
          .subscribe(response => {
            const newBuildNumber = response.buildNumber;
            const user = this.tokenService.getUser();
            if (user && this.tokenService.isLoggedIn()) {
              user.settings = new ValidadorSettingsUser(
                user.settings,
                user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !==
                  undefined
              ).getUserSettingsBody(user.settings) as any;
              if (user.settings['primeiro_acesso']) {
                this.buildIsUpToDateSubject.next(true);
              } else if (
                user.settings['version']['web_version'] === 'UNKNOWN'
              ) {
                localStorage.setItem(KEY_VERSION, newBuildNumber.toString());
                this.buildIsUpToDateSubject.next(false);
              } else {
                localStorage.setItem(KEY_VERSION, newBuildNumber.toString());
                this.buildIsUpToDateSubject.next(
                  user.settings['version']['web_version'] === newBuildNumber
                );
              }
            }
          });
      }
    });
  }
}
